(function ($) {
"use strict";

   

    // video_active        
        $(".video_active").owlCarousel({
        autoplay:true,
        autoplayTimeout:15000,
        loop:true,
        items:1,
        dots:true,
        nav:false,

       });
  
  


//     video_background
    
    jQuery("#bgndVideo").YTPlayer({
        showControls:false
    });
     




})(jQuery);